import { Typography } from "antd"

import "./styles.less"

const { Text } = Typography
const PrivacyPolicy = () => {
  return (
    <Text type="secondary" className="privacy-policy-block">
      By signing up, you agree to our{" "}
      <a href="https://www.chargeback.io/privacy-policy" target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>{" "}
      and{" "}
      <a
        href="https://www.chargeback.io/terms-and-conditions"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms & Conditions
      </a>
    </Text>
  )
}

export default PrivacyPolicy
